import { useQuery } from "react-query";
import axiosInstance from "../../services/axiosInstance";

export const fetchPOpup = async ({
  deliveryMethod,
}: {
  deliveryMethod: string;
}): Promise<PopupAdminDetailResDto> => {
  const response = await axiosInstance.get("/popups/" + deliveryMethod);
  return response?.data?.result;
};

export const usePopupQuery = (deliveryMethod: string) => {
  return useQuery<PopupAdminDetailResDto>(
    ["popup", deliveryMethod],
    () => fetchPOpup({ deliveryMethod }),
    {
      enabled: !!deliveryMethod,
    },
  );
};
